import { render, staticRenderFns } from "./changeRole.vue?vue&type=template&id=ac9b56ea&"
import script from "./changeRole.vue?vue&type=script&lang=js&"
export * from "./changeRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports